import * as common from './types';

export const ERROR = 'ERROR';
export const APPINFO = 'APPINFO';
export const IS_MOBILE = 'IS_MOBILE';
export const MOBILE_OS = 'MOBILE_OS';
export const LOADING = 'LOADING';
export const APP_LOADED = 'APP_LOADED';
export const SHOW_LOADER = 'SHOW_LOADER';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const SNACKBAR_POSX = 'SNACKBAR_POSX';
export const SNACKBAR_POSY = 'SNACKBAR_POSY';
export const SNACKBAR_MESSAGE = 'SNACKBAR_MESSAGE';
export const SNACKBAR_COLOR = 'SNACKBAR_COLOR';
export const SNACKBAR_DURATION = 'SNACKBAR_DURATION';
export const SNACKBAR_MULTILINE = 'SNACKBAR_MULTILINE';
export const SHOW_DIALOG = 'SHOW_DIALOG';
export const DIALOG_TYPE = 'DIALOG_TYPE';
export const DIALOG_TITLE = 'DIALOG_TITLE';
export const DIALOG_MESSAGE = 'DIALOG_MESSAGE';
export const DIALOG_HTML = 'DIALOG_HTML';
export const DIALOG_ICON = 'DIALOG_ICON';
export const NAV_DRAWER = 'NAV_DRAWER';
export const NAV_MINI = 'NAV_MINI';
export const SHOW_REQUIRED_UPDATE_PASSWORD_DIALOG =
  'SHOW_REQUIRED_UPDATE_PASSWORD_DIALOG';
export const CUSTOM_HEADER_TEXT = 'CUSTOM_HEADER_TEXT';

const getters = {
  [APPINFO]: state => state.appInfo,
  [IS_MOBILE]: state => state.isMobile,
  [MOBILE_OS]: state => state.mobileOS,
  [ERROR]: state => state.error,
  //kakaoSdkKey: state => state.kakaoSdkKey,
  [LOADING]: state => state.loading,
  [APP_LOADED]: state => state.appLoaded,
  [SHOW_LOADER]: state => state.showLoader,
  [SHOW_SNACKBAR]: state => state.snackbar.showSnackbar,
  [SNACKBAR_POSX]: state => state.snackbar.snackbarPosX,
  [SNACKBAR_POSY]: state => state.snackbar.snackbarPosY,
  [SNACKBAR_MESSAGE]: state => state.snackbar.snackbarMessage,
  [SNACKBAR_COLOR]: state => state.snackbar.snackbarColor,
  [SNACKBAR_DURATION]: state => state.snackbar.snackbarDuration,
  [SNACKBAR_MULTILINE]: state => state.snackbar.snackbarMultiLine,
  [SHOW_DIALOG]: state => state.dialog.dialogShow,
  [DIALOG_TYPE]: state => state.dialog.dialogType,
  [DIALOG_TITLE]: state => state.dialog.dialogTitle,
  [DIALOG_MESSAGE]: state => state.dialog.dialogMessage,
  [DIALOG_HTML]: state => state.dialog.dialogHtml,
  [DIALOG_ICON]: state => state.dialog.dialogIcon,
  [NAV_DRAWER]: state => state.navigation.drawer,
  [NAV_MINI]: state => state.navigation.mini,
  [SHOW_REQUIRED_UPDATE_PASSWORD_DIALOG]: state =>
    state.showRequiredUpdatePasswordDialog,
  [CUSTOM_HEADER_TEXT]: state => state.customHeaderText,
};

export default getters;
